import Link from "next/link";
import LinkButton from "../_atoms/linkbutton";
import { IServiceData } from "@/types/strapi";
import { GlowingEffect } from "../ui/glowing-effect";
import Tag from "../_atoms/tag";

function ServiceArticle({
	service,
	title,
}: {
	service: IServiceData;
	title: string;
}) {
	return (
		<article
			key={service.id}
			className="rounded-xl border bg-white p-4 relative"
		>
			<GlowingEffect
				spread={40}
				glow
				proximity={64}
				inactiveZone={0.01}
			/>
			<Link
				className="flex h-full flex-col justify-between gap-3"
				href={service.single ? "/contact" : `/services/${service.slug}`}
			>
				<div className="content grid gap-3">
					<h3 className="font-bold text-lg">{title}</h3>
					{service.excerpt && (
						<p className="text-base text-muted-foreground">
							{service.excerpt}
						</p>
					)}
					{service.tags && service.tags.length > 0 && (
						<div className="flex flex-wrap gap-2">
							{service.tags.map((tag) => (
								<Tag key={tag.id} {...tag} />
							))}
						</div>
					)}
				</div>
				<div className="mt-3">
					<LinkButton
						text={
							service.single ? "Contactez-moi" : "En savoir plus"
						}
					/>
				</div>
			</Link>
		</article>
	);
}
export default ServiceArticle;
